const Index = () => import(/* webpackChunkName: "manager" */ './Index');

export default {
    routes: [
        {
            path: '/book/rept/index',
            name: 'book_rept_index',
            component: Index
        }
    ]
}
